var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElgato(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.882 8.396.026.02 9.95 5.717a12.025 12.025 0 0 1-4.04 7.026A11.926 11.926 0 0 1 12.098 24a11.854 11.854 0 0 1-8.453-3.514A11.95 11.95 0 0 1 .143 12c0-3.204 1.244-6.219 3.501-8.485A11.85 11.85 0 0 1 12.097 0c2.44 0 4.785.733 6.783 2.119a11.983 11.983 0 0 1 4.628 6.308l-2.126 1.236a9.492 9.492 0 0 0-.262-.87c-1.354-3.83-4.98-6.405-9.023-6.405-5.28 0-9.575 4.313-9.575 9.612 0 5.3 4.295 9.611 9.575 9.611a9.455 9.455 0 0 0 5.66-1.864 9.6 9.6 0 0 0 3.43-4.737l.007-.041L9.59 8.305v7.225l4-2.313 2.06 1.18-5.996 3.47-2.12-1.213v-9.46L9.652 5.97l4.231 2.428-.001-.002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElgato);
export default __webpack_public_path__ + "static/media/elgato.6d252d707442af51ed0305349e61402f.svg";
export { ForwardRef as ReactComponent };